function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m10.5 2.299.006.005 5.997 5.257a2.25 2.25 0 0 1 .747 1.685V18A2.25 2.25 0 0 1 15 20.25H3A2.25 2.25 0 0 1 .75 18V9.254a2.25 2.25 0 0 1 .748-1.693l5.997-5.257.005-.005a2.25 2.25 0 0 1 3 0Zm.5 17.45h.75V14A1.75 1.75 0 0 0 10 12.25H8A1.75 1.75 0 0 0 6.25 14v5.75H11Zm1.25-.75v.75H15A1.75 1.75 0 0 0 16.75 18V9.25a1.75 1.75 0 0 0-.595-1.313h-.001l-5.999-5.25a1.75 1.75 0 0 0-2.31 0l-5.999 5.25A1.75 1.75 0 0 0 1.25 9.25V18A1.75 1.75 0 0 0 3 19.75h2.75V14A2.25 2.25 0 0 1 8 11.75h2A2.25 2.25 0 0 1 12.25 14v5Z",
  fill: "#000",
  stroke: "#FBFBFB",
  strokeWidth: 1.5
});

function SvgIconHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.639041fe6be7a9e953e798dc406fd652.svg";
export { ForwardRef as ReactComponent };